module.exports = __webpack_public_path__ + "img/rating_star_icon.dbc3d513.svg";